import { FC } from "react";

import Skeleton from "./../../../../../libs/Skeleton";

import styles from "./styles.module.scss";

const EditModePagesLoading: FC = () => (
    <div className={styles.skeletonsContainer}>
        <div>
            <Skeleton width="80px" height="20px" waveWidth={80} />
            <Skeleton width="80px" height="20px" waveWidth={80} />
            <Skeleton width="80px" height="20px" waveWidth={80} />
            <Skeleton width="80px" height="20px" waveWidth={80} />
        </div>

        <div>
            <Skeleton width="24px" height="24px" waveWidth={24} borderRadius="50%" />
            <Skeleton width="24px" height="24px" waveWidth={24} borderRadius="50%" />
            <Skeleton width="24px" height="24px" waveWidth={24} borderRadius="50%" />
        </div>
    </div>
);

export default EditModePagesLoading;
